(() => {
  // app.js
  var $ = (selector, scope = document) => scope.querySelector(selector);
  var $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  var reviewCarousel = $("[data-review-carousel]");
  var reviewViewport = $("[data-review-viewport]", reviewCarousel);
  var reviewPrevious = $("[data-review-prev]", reviewCarousel);
  var reviewNext = $("[data-review-next]", reviewCarousel);
  var reviewStatus = $("[data-review-status]", reviewCarousel);
  var visibleReviewCards = () => $$("[data-review-card]").filter((card) => !card.hidden);
  var reviewPageSize = () => window.matchMedia("(max-width: 800px)").matches ? 1 : 2;
  var reviewCardStride = () => {
    const cards = visibleReviewCards();
    if (cards.length > 1)
      return cards[1].offsetLeft - cards[0].offsetLeft;
    return cards[0]?.getBoundingClientRect().width || reviewViewport?.clientWidth || 0;
  };
  function updateReviewCarousel() {
    if (!reviewViewport)
      return;
    const cards = visibleReviewCards();
    const pageSize = reviewPageSize();
    const maxScroll = Math.max(0, reviewViewport.scrollWidth - reviewViewport.clientWidth);
    const firstIndex = Math.round(reviewViewport.scrollLeft / Math.max(1, reviewCardStride()));
    const first = Math.min(cards.length, firstIndex + 1);
    const last = Math.min(cards.length, first + pageSize - 1);
    reviewPrevious.disabled = reviewViewport.scrollLeft <= 2;
    reviewNext.disabled = reviewViewport.scrollLeft >= maxScroll - 2;
    reviewStatus.textContent = cards.length ? `Showing stories ${first} through ${last} of ${cards.length}` : "No stories in this category";
  }
  function moveReviewCarousel(direction) {
    const step = reviewPageSize() === 1 ? reviewCardStride() : reviewViewport?.clientWidth || 0;
    reviewViewport?.scrollBy({ left: direction * step, behavior: "smooth" });
  }
  reviewPrevious?.addEventListener("click", () => moveReviewCarousel(-1));
  reviewNext?.addEventListener("click", () => moveReviewCarousel(1));
  reviewViewport?.addEventListener("scroll", updateReviewCarousel, { passive: true });
  reviewViewport?.addEventListener("keydown", (event) => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight")
      return;
    event.preventDefault();
    moveReviewCarousel(event.key === "ArrowRight" ? 1 : -1);
  });
  var reviewDrag = null;
  reviewViewport?.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "mouse" && event.button !== 0)
      return;
    if (event.pointerType === "mouse")
      event.preventDefault();
    reviewDrag = { pointerId: event.pointerId, x: event.clientX, scrollLeft: reviewViewport.scrollLeft };
    reviewViewport.classList.add("is-dragging");
    reviewViewport.setPointerCapture(event.pointerId);
  });
  reviewViewport?.addEventListener("dragstart", (event) => event.preventDefault());
  reviewViewport?.addEventListener("pointermove", (event) => {
    if (!reviewDrag || reviewDrag.pointerId !== event.pointerId)
      return;
    reviewViewport.scrollLeft = reviewDrag.scrollLeft + reviewDrag.x - event.clientX;
  });
  function finishReviewDrag(event) {
    if (!reviewDrag || reviewDrag.pointerId !== event.pointerId)
      return;
    reviewDrag = null;
    reviewViewport.classList.remove("is-dragging");
    updateReviewCarousel();
  }
  reviewViewport?.addEventListener("pointerup", finishReviewDrag);
  reviewViewport?.addEventListener("pointercancel", finishReviewDrag);
  var verticalReviewWheelFrame = 0;
  reviewViewport?.addEventListener("wheel", (event) => {
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX))
      return;
    const preservedScrollLeft = reviewViewport.scrollLeft;
    reviewViewport.classList.add("is-vertical-wheeling");
    cancelAnimationFrame(verticalReviewWheelFrame);
    verticalReviewWheelFrame = requestAnimationFrame(() => {
      reviewViewport.scrollLeft = preservedScrollLeft;
      reviewViewport.classList.remove("is-vertical-wheeling");
      updateReviewCarousel();
    });
  }, { passive: true });
  window.addEventListener("resize", updateReviewCarousel);
  updateReviewCarousel();
  var menuToggle = $("[data-menu-toggle]");
  var mobileMenu = $("#mobile-menu");
  var supportToggles = $$("[data-support-toggle]");
  function closeSupportMenus({ restoreFocus = false } = {}) {
    supportToggles.forEach((toggle) => {
      const menu = document.getElementById(toggle.getAttribute("aria-controls"));
      const wasOpen = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", "false");
      if (menu)
        menu.hidden = true;
      if (restoreFocus && wasOpen)
        toggle.focus();
    });
  }
  supportToggles.forEach((toggle) => {
    toggle.addEventListener("click", (event) => {
      event.stopPropagation();
      const menu = document.getElementById(toggle.getAttribute("aria-controls"));
      const willOpen = toggle.getAttribute("aria-expanded") !== "true";
      closeSupportMenus();
      toggle.setAttribute("aria-expanded", String(willOpen));
      if (menu)
        menu.hidden = !willOpen;
    });
  });
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".support-nav"))
      closeSupportMenus();
  });
  function closeMenu({ restoreFocus = false } = {}) {
    mobileMenu.hidden = true;
    menuToggle.setAttribute("aria-expanded", "false");
    if (restoreFocus)
      menuToggle.focus();
  }
  menuToggle?.addEventListener("click", () => {
    const willOpen = menuToggle.getAttribute("aria-expanded") !== "true";
    menuToggle.setAttribute("aria-expanded", String(willOpen));
    mobileMenu.hidden = !willOpen;
  });
  $$("a", mobileMenu).forEach((link) => link.addEventListener("click", () => {
    closeSupportMenus();
    closeMenu();
  }));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      if (!mobileMenu.hidden)
        closeMenu({ restoreFocus: true });
      closeSupportMenus({ restoreFocus: true });
    }
  });
  var newsletter = $("[data-newsletter]");
  newsletter?.addEventListener("submit", (event) => {
    event.preventDefault();
    const email = $("input[type='email']", newsletter);
    if (!email.checkValidity()) {
      email.reportValidity();
      return;
    }
    $("[data-newsletter-status]").textContent = "Thanks — you’re subscribed.";
    email.value = "";
  });
  $$("[data-faq] details").forEach((detail) => {
    detail.addEventListener("toggle", () => {
      detail.querySelector("summary").setAttribute("aria-expanded", String(detail.open));
    });
  });
  document.documentElement.dataset.appReady = "true";
})();
